import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom'
import { StateBlock, ToastProvider } from '@w7/ui'
import { AppShell } from './AppShell'
import { ThemeProvider } from './theme'
import { ShortKeyProvider } from './ShortKeyContext'
import { AuthGate } from '@/auth/AuthGate'
import { LoginPage } from '@/features/login/LoginPage'
import { ChangePasswordPage } from '@/features/login/ChangePasswordPage'
import { SessionMarketPage } from '@/features/session/SessionMarketPage'
import { RunListPage } from '@/features/runs/RunListPage'
import { RateListPage } from '@/features/rates/RateListPage'
import { RateCategoryPage } from '@/features/rates/RateCategoryPage'
import { ResultListPage } from '@/features/results/ResultListPage'
import { SubMarketInfoPage } from '@/features/submarket/SubMarketInfoPage'
import { CreateSubMarketInfoPage } from '@/features/submarket/CreateSubMarketInfoPage'
import { UserListPage } from '@/features/users/UserListPage'
import { CreateUserPage } from '@/features/users/CreateUserPage'
import { PlDetailsPage } from '@/features/pl/PlDetailsPage'
import { FetchMarketPage } from '@/features/fetch/FetchMarketPage'
import { MaintenancePage } from '@/features/maintenance/MaintenancePage'
import '@/styles/app.css'

const client = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, retry: 1, refetchOnWindowFocus: true },
  },
})

function ShellLayout() {
  return (
    <AuthGate>
      <ShortKeyProvider>
        <AppShell>
          <Outlet />
        </AppShell>
      </ShortKeyProvider>
    </AuthGate>
  )
}

export function App() {
  return (
    <QueryClientProvider client={client}>
      <ThemeProvider>
        <ToastProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<LoginPage />} />
              <Route path="/maintenance" element={<MaintenancePage />} />
              <Route element={<ShellLayout />}>
                <Route path="/sessionmarket" element={<SessionMarketPage />} />
                <Route path="/runlist" element={<RunListPage />} />
                <Route path="/ratelist" element={<RateListPage />} />
                <Route path="/ratecategory" element={<RateCategoryPage />} />
                <Route path="/resultlist" element={<ResultListPage />} />
                <Route path="/fetchMarket" element={<FetchMarketPage />} />
                <Route path="/submarketinfo" element={<SubMarketInfoPage />} />
                <Route path="/createsubmarketinfo" element={<CreateSubMarketInfoPage />} />
                <Route path="/createuser" element={<CreateUserPage />} />
                <Route path="/userList" element={<UserListPage />} />
                <Route path="/changePassword" element={<ChangePasswordPage />} />
                <Route path="/pldetails" element={<PlDetailsPage />} />
                <Route
                  path="*"
                  element={
                    <StateBlock icon="search" title="That page does not exist">
                      Unknown route.
                    </StateBlock>
                  }
                />
              </Route>
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
